import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Radio,
  RadioGroup,
  Select,
  // TextareaAutosize,
  // TextField,
  Typography
} from '@mui/material';
import { Form } from 'formik';
import React from 'react';
import { gridSpacing } from 'store/constant';
import { useTheme } from '@mui/material/styles';
import AnimateButton from 'ui-component/extended/AnimateButton';
import DocumentUploadTicket from '../files/uploader';
import { useGetEnterpriseMachineAllList, useGetTicketReasonDataList } from 'hooks/useTickets';
const EnterpriseUserTicketForm = ({
  errors,
  handleBlur,
  handleChange,
  handleSubmit,
  isSubmitting,
  touched,
  values,

  setFieldValue,

  btnName,
  isLoadingTicket,

  // setTouched,
  ticketDetails
}) => {
  const enterprise = JSON.parse(localStorage.getItem('userData'));
  const { data: allEnterpriseMachineList } = useGetEnterpriseMachineAllList({
    enterpriseID: enterprise?.enterprise?.id
  });

  const { data: allTicketReasonDataList } = useGetTicketReasonDataList();

  const theme = useTheme();
  return (
    <>
      <Form>
        <Grid
          container
          spacing={gridSpacing}
          sx={{
            alignContent: 'center'
          }}
        >
          <Grid item xs={12}>
            <Typography component="h4" variant="h2" sx={{ mb: 2 }}>
              Ticket Details
            </Typography>
            <Grid container spacing={gridSpacing}>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <FormControl fullWidth error={Boolean(touched.subject && errors.subject)} sx={{ ...theme.typography.customInput }}>
                  <InputLabel htmlFor="outlined-adornment-email-login">Subject * </InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-secondary-address"
                    type="text"
                    value={values.subject}
                    name="subject"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    label="Subject *"
                    placeholder="e.g. Malfunctioning Machine"
                    inputProps={{}}
                    autoComplete="off"
                  />
                  {touched.subject && errors.subject && (
                    <FormHelperText
                      error
                      id="standard-weight-helper-text-email-login"
                      sx={{
                        fontSize: '13.8px'
                      }}
                    >
                      {errors.subject}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <FormControl fullWidth error={Boolean(touched.reason && errors.reason)} sx={{ ...theme.typography.customInput }}>
                  <InputLabel htmlFor="outlined-adornment-email-login">Select Reason *</InputLabel>
                  <Select
                    label="Select Reason *"
                    placeholder="e.g. Electrical issue"
                    value={values.reason}
                    onChange={handleChange}
                    name="reason"
                    inputProps={{ 'aria-label': 'Without label' }}
                    labelId="retailer-primary-reason-label"
                  >
                    {allTicketReasonDataList?.data?.map((item, i) => (
                      <MenuItem value={item?.reason} key={i}>
                        {item?.reason}
                      </MenuItem>
                    ))}
                  </Select>
                  {touched.reason && errors.reason && (
                    <FormHelperText
                      error
                      id="standard-weight-helper-text-email-login"
                      sx={{
                        fontSize: '13.8px'
                      }}
                    >
                      {errors.reason}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <FormControl fullWidth error={Boolean(touched.machine && errors.machine)} sx={{ ...theme.typography.customInput }}>
                  <InputLabel htmlFor="outlined-adornment-email-login">Select Machine *</InputLabel>
                  <Select
                    label="Select Machine *"
                    placeholder="e.g. SB123SB86"
                    value={values.machine}
                    onChange={handleChange}
                    name="machine"
                    inputProps={{ 'aria-label': 'Without label' }}
                    labelId="retailer-primary-machine-label"
                  >
                    {allEnterpriseMachineList?.map((item, i) => (
                      <MenuItem value={item?.machineId} key={i}>
                        {item?.machineId}
                      </MenuItem>
                    ))}
                    {/* <MenuItem value={'Machine1'}>Machine 1</MenuItem> */}
                  </Select>
                  {touched.machine && errors.machine && (
                    <FormHelperText
                      error
                      id="standard-weight-helper-text-email-login"
                      sx={{
                        fontSize: '13.8px'
                      }}
                    >
                      {errors.machine}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <FormControl error={Boolean(touched.priority && errors.priority)}>
                  <FormLabel id="demo-radio-buttons-group-label">Priority*</FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="priority"
                    value={values.priority}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  >
                    <FormControlLabel value="High" control={<Radio />} label="High" />

                    <FormControlLabel value="Low" control={<Radio />} label="Low" />
                    <FormControlLabel value="Medium" control={<Radio />} label="Medium" />
                  </RadioGroup>

                  {touched.priority && errors.priority && (
                    <FormHelperText
                      error
                      id="standard-weight-helper-text-email-login"
                      sx={{
                        fontSize: '13.8px'
                      }}
                    >
                      {errors.priority}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <FormControl
                  className="ticket_detailstextarea"
                  fullWidth
                  error={Boolean(touched.notes && errors.notes)}
                  sx={{ ...theme.typography.customInput }}
                >
                  <InputLabel htmlFor="outlined-adornment-email-login">Notes</InputLabel>
                  <OutlinedInput
                    value={values.notes}
                    onChange={handleChange}
                    multiline
                    rows={4}
                    placeholder="Type your query here..."
                    fullWidth
                    variant="outlined"
                    name="notes"
                    label="Notes"
                  />

                  {touched.notes && errors.notes && (
                    <FormHelperText
                      error
                      id="standard-weight-helper-text-email-login"
                      sx={{
                        fontSize: '13.8px'
                      }}
                    >
                      {errors.notes}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={12}>
                <Grid>
                  <div style={{ padding: '10px 15px 15px' }} className="field-input-all">
                    <Typography variant="h5" component={'span'} className="font-medium">
                      Related Files/Documents
                    </Typography>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      style={{
                        marginTop: '10px'
                      }}
                    >
                      <DocumentUploadTicket
                        {...{
                          values,
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          handleSubmit,
                          isSubmitting,
                          setFieldValue,
                          // resetForm,
                          ticketDetails
                        }}
                      />
                    </Grid>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            {errors.submit && (
              <Box sx={{ mt: 3 }}>
                <FormHelperText error>{errors.submit}</FormHelperText>
              </Box>
            )}
            <Box sx={{ mt: 5, display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
              <Box sx={{ display: 'inline-block' }}>
                <AnimateButton>
                  <Button
                    disableElevation
                    disabled={isLoadingTicket}
                    size="large"
                    type="submit"
                    variant="contained"
                    color="secondary"
                    style={{
                      color: 'white',
                      minWidth: '200px',
                      margin: '0px auto'
                    }}
                  >
                    {isLoadingTicket ? (
                      <>
                        <CircularProgress
                          sx={{
                            color: 'white',
                            height: 20,
                            width: 20
                          }}
                        />
                      </>
                    ) : (
                      `${btnName} Ticket`
                    )}
                  </Button>
                </AnimateButton>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Form>
    </>
  );
};

export default EnterpriseUserTicketForm;
